import { createFileRoute } from "@tanstack/react-router";
import { BASE_URL } from "@/lib/constants";
import { generalFaqs } from "@/lib/data/faq-data";
import { getFeaturedBlogs } from "@/lib/utils/blog.utils";
import {
	generateFAQSchema,
	generateLocalBusinessSchema,
	generateOrganizationSchema,
	generateWebsiteSchema,
} from "@/lib/utils/schema.utils";
import { generateSeo } from "@/lib/utils/seo";

export const Route = createFileRoute("/")({
	head: () =>
		generateSeo({
			title:
				"CraftLayer | Best Digital Marketing & Web Development Agency in Bangalore",
			description:
				"CraftLayer offers expert SEO, Social Media Marketing (SMM), Ads, and Custom Web Development (WordPress, React, Next.js) in Bangalore. Transform your digital presence with data-driven strategies.",
			url: BASE_URL,
			keywords: [
				"digital marketing agency bangalore",
				"web development company bangalore",
				"seo services bangalore",
				"smm agency",
				"wordpress developers",
				"next.js experts",
				"CraftLayer",
				"website design bangalore",
			],
		}),
	loader: async () => {
		const featuredBlogs = await getFeaturedBlogs();
		const faqs = generalFaqs;

		const faqSchema = generateFAQSchema(faqs);
		const organizationSchema = generateOrganizationSchema();
		const localBusinessSchema = generateLocalBusinessSchema();
		const websiteSchema = generateWebsiteSchema();

		return {
			featuredBlogs,
			faqs,
			faqSchema,
			organizationSchema,
			localBusinessSchema,
			websiteSchema,
		};
	},
});
